import * as types from '../constants/actionTypes';

const initialState = {
  items: [],
  loading: true,
  singleService: {}
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.CREATE_SERVICES_CATEGORY_SUCCESS:
      return {
        ...state,
        items: action.payload,
        singleService: action.payload,
        loading: false
      };
    case types.ADD_SINGLE_SERVICE_SUCCESS:
      return {
        ...state,
        items: action.payload,
        singleService: action.payload,
        loading: false
      };
    case types.SINGLE_PACKAGE_SERVICE_SUCCESS:
      return {
        ...state,
        items: action.payload,
        singleService: action.payload,
        loading: false
      };
    case types.ALL_SINGLE_SERVICES_SUCCESS:
      return {
        ...state,
        items: action.payload,
        singleService: action.payload,
        loading: false
      };
    case types.UPDATE_PACKAGE_SERVICE_SUCCESS:
      return {
        ...state,
        items: action.payload,
        singleService: action.payload,
        loading: false
      };
    case types.DELETE_PACKAGE_SERVICE_SUCCESS:
      return {
        ...state,
        items: action.payload,
        singleService: action.payload,
        loading: false
      };
    default:
      return state;
  }
}
